import { TYPES } from "./finance_supporter.type";
import { getDocs, onSnapshot, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider

export const getFinanceSupporterByDate =
  ({ from, to }, callback) =>
  (dispatch) => {
    const start = from?.startOf("days")?.toDate();
    const end = to?.endOf("days")?.toDate();
    console.log({ start, end });
    const uid = auth?.currentUser?.uid;
    setFinanceSupporterAllSuccess(dispatch, null);
    const cRef = getRefs().supporter;
    const c0 = where("owner", "==", uid);
    const c1 = where("database", "==", "draft");
    const c2 = where("collection", "==", "dialog");
    const c3 = where("source", "==", "supporter");
    const c4 = where("setAt", ">=", start);
    const c5 = where("setAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2, c3, c4, c5);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        console.log("snap dates:" + JSON.stringify(data));
        setFinanceSupporterAllSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

// ========= cloud function =========//
// ========= local function =========//
export const setFinanceSupporterAll = (data, callback) => (dispatch) => {
  setFinanceSupporterAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceSupporterOpenAdd = (data, callback) => (dispatch) => {
  setFinanceSupporterOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceSupporterOpenEdit = (data, callback) => (dispatch) => {
  setFinanceSupporterOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceSupporterSelected = (data, callback) => (dispatch) => {
  setFinanceSupporterSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceSupporterSearch = (data, callback) => (dispatch) => {
  setFinanceSupporterSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
export const setFinanceSupporterDates = (data, callback) => (dispatch) => {
  setFinanceSupporterDatesSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setFinanceSupporterAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_ALL,
    payload: data,
  });
};

const setFinanceSupporterOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_OPEN_ADD,
    payload: data,
  });
};

const setFinanceSupporterOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_OPEN_EDIT,
    payload: data,
  });
};

const setFinanceSupporterSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_SELECTED,
    payload: data,
  });
};

const setFinanceSupporterSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_SEARCH,
    payload: data,
  });
};

const setFinanceSupporterDatesSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_SUPPORTER_DATES,
    payload: data,
  });
};
